<igx-checkbox igxRipple #showHidden>Покажи скритите</igx-checkbox>
<button igxButton igxRipple (click)="startCreateProgram(programDialog)">Добави програма</button>
<div class="drag_wrapper">
    @for(program of programs | hidden:showHidden.checked | sorting:sortPipeTrigger:'order'; track program.id){
    <div class="drag_container" #drag igxDrag igxDrop (dragStart)="programDragStart(program)"
        (ghostCreate)="programGhostCreate(drag)" (enter)="programDragEnter(program)" (dragEnd)="programDragEnd(drag)"
        [ghostClass]="'drag_ghost_class'">
        <igx-card elevated>
            <igx-card-header>
                <h3 igxCardHeaderTitle>
                    @if (program.deleted) {
                    <s>{{ program.name }}</s>
                    }
                    @else {
                    {{ program.name }}
                    }
                </h3>
            </igx-card-header>
            <igx-card-actions>
                <button title="Редактирай" igxIconButton="flat" (click)="startProgramUpdate(program)" igxEnd>
                    <igx-icon>edit</igx-icon>
                </button>

                @if (program.deleted) {
                <button title="Въстанови" igxIconButton="flat" (click)="setProgramHidden(program, false)" igxEnd>
                    <igx-icon>restore_from_trash</igx-icon>
                </button>
                }
                @else {
                <button title="Изтрий" igxIconButton="flat" (click)="setProgramHidden(program, true)" igxEnd>
                    <igx-icon>delete</igx-icon>
                </button>
                }
                <button title="Отстъпки" igxIconButton="flat" (click)="addDiscounts(program, discountDialog)" igxEnd>
                    <igx-icon>savings</igx-icon>
                </button>
                <button title="Информация" igxIconButton="flat" (click)="programInfo(program, infoDialog)" igxEnd>
                    <igx-icon>info</igx-icon>
                </button>
            </igx-card-actions>
        </igx-card>
    </div>
    }
</div>
<div #outlet style="z-index: 0; opacity: 0.9999;"></div>
<igx-dialog #programDialog>
    <igx-dialog-title>{{ dialogOkButtonText }} програма</igx-dialog-title>
    <form #form [formGroup]="programForm" class="dialog">
        <div class="container">
            <div class="inputs">
                <igx-input-group class="input" type="border">
                    <label igxLabel>Име на програмата</label>
                    <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
                </igx-input-group>
                <igx-select class="input" name="transportSchema" formControlName="transportSchema" type="border"
                    (selectionChanging)="transportSchemaChanged($event)">
                    <label igxLabel>Транспортна схема</label>
                    <igx-select-item *ngFor="let schema of transportSchemas | sorting" [value]="schema.id">
                        {{ schema.name }}
                    </igx-select-item>
                </igx-select>
                <igx-input-group class="input small" type="border">
                    <label igxLabel>Срок за депозит</label>
                    <input igxInput [igxTextSelection]="true" type="number" name="depositDueDays"
                        formControlName="depositDueDays" />
                </igx-input-group>
                <igx-checkbox class="input" name="winter" formControlName="winter" type="border">
                    Зимна
                </igx-checkbox>
            </div>
            <div class="inputs">
                <igx-input-group class="input" type="border">
                    <label igxLabel>Добави продукт</label>
                    <input igxInput #productInput [igxTextSelection]="true" />
                    <button igxIconButton="flat" igxSuffix (buttonClick)="addProduct(productInput)">
                        <igx-icon>add</igx-icon>
                    </button>
                </igx-input-group>
                <igx-chips-area (reorder)="productsOrderChanged($event)">
                    @for(product of products; track product.order; let i = $index) {
                    <igx-chip style="--ig-size: var(--ig-size-large)" [id]="product?.order?.toString() ?? i.toString()"
                        [draggable]="true" [disabled]="!!productInput.value">
                        {{product.name}}
                        <button igxIconButton="flat" igxSuffix
                            (buttonClick)="editProduct($event, product, productInput)">
                            <igx-icon>edit</igx-icon>
                        </button>
                    </igx-chip>
                    }
                </igx-chips-area>
            </div>
            <igx-card elevated>
                <igx-accordion formArrayName="periods">
                    @for(period of periodsForm(); track period.controls.id; let p = $index) {
                    <igx-expansion-panel [formGroup]="period">
                        <igx-expansion-panel-header #header>
                            <igx-expansion-panel-description>
                                <div class="row">
                                    {{ generatePeriodDescription(period) }}
                                    <igx-simple-combo [data]="products" name="product" formControlName="product"
                                        valueKey="id" displayKey="name" type="border">
                                        <label igxLabel>Продукт</label>
                                    </igx-simple-combo>
                                    <igx-combo #sportsCombo [data]="sports | sorting" name="sports"
                                        formControlName="sports" valueKey="id" displayKey="name" type="border"
                                        (selectionChanging)="sportSelected($event, p)">
                                        <label igxLabel>Спорт</label>
                                    </igx-combo>
                                    <igx-combo [data]="levels[p] | sorting" name="levels" formControlName="levels"
                                        valueKey="id" displayKey="name" type="border">
                                        <label igxLabel>Ниво</label>
                                    </igx-combo>
                                </div>
                            </igx-expansion-panel-description>
                        </igx-expansion-panel-header>
                        <igx-expansion-panel-body>
                            <div class="row">
                                <igx-select class="input" name="transportSchema" formControlName="transportSchema"
                                    type="border">
                                    <label igxLabel>Транспортна схема</label>
                                    <igx-select-item *ngFor="let schema of transportSchemas | sorting"
                                        [value]="schema.id">
                                        {{ schema.name }}
                                    </igx-select-item>
                                </igx-select>
                                <button type="button" igxButton="outlined"
                                    (click)="openCalendarDialog($event, calendarDialog)">
                                    <span>Дати</span>
                                    <igx-icon>today</igx-icon>
                                </button>
                                <igx-input-group *ngIf="period.controls.package.value" class="input middle"
                                    type="border">
                                    <label igxLabel>Дати</label>
                                    <input igxInput [igxTextSelection]="true" type="text" name="description"
                                        formControlName="description" />
                                </igx-input-group>
                                <igx-input-group *ngIf="!period.controls.package.value" class="input middle"
                                    type="border">
                                    <label igxLabel>Дати</label>
                                    <input igxInput [disabled]="true" type="text" placeholder="Само за пакети" />
                                </igx-input-group>
                                <igx-checkbox class="input" name="package" formControlName="package" type="border"
                                    (change)="isPackageChange($event, p)">
                                    Пакет
                                </igx-checkbox>
                                <igx-checkbox class="input" name="disabled" formControlName="disabled" type="border">
                                    Скрита
                                </igx-checkbox>
                                <button type="button" igxIconButton="flat"
                                    (click)="tryToDeletePeriod($event, p, deletePeriodDialog)">
                                    <igx-icon>delete</igx-icon>
                                </button>
                            </div>
                            <div class="inputs">
                                <igx-slider class="input slider" #slider name="ageRange" formControlName="ageRange"
                                    [type]="'range'" [showTicks]="true" [maxValue]="30" [minValue]="0"
                                    [primaryTicks]="4" [primaryTickLabels]="true" [secondaryTicks]="9"
                                    [secondaryTickLabels]="false" [step]="1" [lowerBound]="3" [upperBound]="50">
                                    <ng-template igxSliderTickLabel let-value>
                                        {{ formatLabel(value) }}
                                    </ng-template>
                                </igx-slider>
                                <igx-input-group class="input small" type="border">
                                    <label igxLabel>Капацитет</label>
                                    <input igxInput [igxTextSelection]="true" type="number" name="capacity"
                                        formControlName="capacity" />
                                </igx-input-group>
                                <igx-input-group class="input small" type="border">
                                    <label igxLabel>Цена</label>
                                    <input igxInput [igxTextSelection]="true" type="number" name="price"
                                        formControlName="price" />
                                </igx-input-group>
                                <igx-input-group class="input small" type="border">
                                    <label igxLabel>Депозит</label>
                                    <input igxInput [igxTextSelection]="true" type="number" name="deposit"
                                        formControlName="deposit" />
                                </igx-input-group>
                                <igx-input-group class="input small" type="border">
                                    <label igxLabel>Дни в пакета</label>
                                    <input igxInput [igxTextSelection]="true" type="number" name="packageDuration"
                                        formControlName="packageDuration" />
                                </igx-input-group>
                            </div>
                            <igx-dialog #calendarDialog leftButtonLabel="Затвори"
                                (leftButtonSelect)="calendarDialog.close()">
                                <igx-calendar class="input" name="dates" formControlName="dates" [monthsViewNumber]="3"
                                    selection="multi" (selected)="datesSelected($event, period)">
                                </igx-calendar>
                            </igx-dialog>
                        </igx-expansion-panel-body>
                    </igx-expansion-panel>
                    }
                </igx-accordion>
                <button class="button" type="button" igxButton="contained" [disabled]="!hasPeriods()"
                    (click)="addPeriod()">
                    Добави период
                </button>
            </igx-card>
        </div>
        <igx-dialog-actions>
            <button igxButton type="button" (click)="closeProgramDialog()">ОТКАЖИ</button>
            <button igxButton type="button" [disabled]="!programForm.valid" (click)="programUpdate()">
                {{dialogOkButtonText}}</button>
            <button igxButton type="button" [disabled]="!programForm.valid" (click)="programUpdateAndClose()">
                {{dialogOkButtonText}} И ЗАТВОРИ</button>
        </igx-dialog-actions>
    </form>
</igx-dialog>
<igx-dialog #discountDialog>
    <app-add-discount #discount></app-add-discount>
    <igx-dialog-actions>
        <button igxButton="flat" igxRipple [igxToggleAction]="discountDialog">ЗАТВОРИ</button>
    </igx-dialog-actions>
</igx-dialog>
<igx-dialog #infoDialog>
    <app-info-program #infoProgram (done)="infoDialog.close()"></app-info-program>
</igx-dialog>
<igx-dialog #deletePeriodDialog>
    <igx-dialog-title>
        <div class="dialog-content">
            <h6>{{deleteDialogMessage}}</h6>
            <div igxDialogActions>
                <button igxButton="outlined" (click)="deletePeriodDialog.close()">Откажи</button>
                <button igxButton="contained" [disabled]="cannotDeletePeriod"
                    (click)="deletePeriod(deletePeriodDialog)">Изтрий</button>
            </div>
        </div>
    </igx-dialog-title>
</igx-dialog>